// NOTE: This controller is used for the bulk_employee_customers_controller actions.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["customersContainer"]

  connect() {
    console.log("EmployeeCustomers controller connected")
  }

  async fetchCustomers(event) {
    const employeeId = event.target.value
    if (!employeeId) {
      this.customersContainerTarget.innerHTML = ""
      return
    }

    try {
      const response = await fetch(`/admin/api/employee-customers/${employeeId}`, {
        headers: {
          "Accept": "application/json"
        }
      })
      
      if (!response.ok) throw new Error("Network response was not ok")
      
      const customers = await response.json()
      this.renderCustomers(customers)
    } catch (error) {
      console.error("Error fetching customers:", error)
      this.customersContainerTarget.innerHTML = "<p>Error loading customers</p>"
    }
  }

  renderCustomers(customers) {
    if (customers.length === 0) {
      this.customersContainerTarget.innerHTML = "<p>No customers found for this employee</p>"
      return
    }

    const checkboxesHtml = `
      <div class="space-y-1 max-h-64 overflow-y-auto grid grid-cols-2 ">
        ${customers.map(customer => `
          <div class="flex items-center">
            <input type="checkbox" 
                   name="message[customer_ids][]" 
                   value="${customer.id}" 
                   id="customer_${customer.id}" 
                   checked 
                   class="h-4 w-4 text-indigo-600 border-gray-300 rounded">
            <label for="customer_${customer.id}" class="ml-2 text-sm text-gray-900">
              ${customer.name || customer.full_name || `Customer ${customer.id}`}
            </label>
          </div>
        `).join('')}
      </div>
      <p class="text-sm text-gray-500 mt-2">All customers are selected by default. Uncheck to exclude.</p>
    `
    
    this.customersContainerTarget.innerHTML = checkboxesHtml
  }
}
